import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import GuiaCssbuySpreadsheet from "@/pages/article-guia/page";
import CssbuyVsPandabuy from "@/pages/article-cssbuy-vs-pandabuy/page";
import MelhoresSneakers from "@/pages/article-melhores-sneakers/page";
import ComoEconomizar from "@/pages/article-como-economizar/page";
import TopProdutos from "@/pages/article-top-produtos/page";
import Streetwear from "@/pages/article-streetwear/page";
import GuiaEnvioEuropa from "@/pages/article-guia-envio/page";
import CssbuySeguro from "@/pages/article-cssbuy-seguro/page";
import AgentesComparacao from "@/pages/article-agentes-comparacao/page";
import ErrosComuns from "@/pages/article-erros-comuns/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/guia-cssbuy-spreadsheet-2026", element: <GuiaCssbuySpreadsheet /> },
  { path: "/cssbuy-vs-pandabuy-spreadsheet", element: <CssbuyVsPandabuy /> },
  { path: "/melhores-sneakers-cssbuy-spreadsheet", element: <MelhoresSneakers /> },
  { path: "/como-economizar-cssbuy-spreadsheet", element: <ComoEconomizar /> },
  { path: "/top-produtos-cssbuy-spreadsheet", element: <TopProdutos /> },
  { path: "/streetwear-cssbuy-spreadsheet", element: <Streetwear /> },
  { path: "/guia-envio-cssbuy-europa", element: <GuiaEnvioEuropa /> },
  { path: "/cssbuy-e-seguro-analise", element: <CssbuySeguro /> },
  { path: "/agentes-china-comparacao-cssbuy", element: <AgentesComparacao /> },
  { path: "/erros-comuns-cssbuy-spreadsheet", element: <ErrosComuns /> },
  { path: "*", element: <NotFound /> },
];

export default routes;